import Select from "react-select";
import { useMemo } from "react";

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: "#A6A6A6",          // darker border
        borderWidth: "2px",            // thicker border
        boxShadow: "none",            // remove blue glow
        "&:focus": {
            borderColor: "#FD64C3"         // even darker on hover
        }
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "#000"
    })
};

function SupplierDropdown({ suppliers = [], setField, selectedValue }) {
    console.log("Selected Value in SupplierDropdown:", selectedValue); 
    const options = useMemo(() => {
        const assigned = suppliers.map(s => ({ value: Number(s.id), label: s.name }));

        return [
            {
                label: "Suppliers",
                options: assigned
            }
            
        ];
    }, [suppliers]);

    if (!suppliers.length) return null;
    return (

        <Select
            options={options}
            placeholder="Please select..."
            isSearchable
            styles={customStyles}
            onChange={(selectedOption) => setField("supplierId", selectedOption ? selectedOption.value : 0)}
            value={options.flatMap(g => g.options).find(o => o.value === Number(selectedValue))}
        />

    );


}

export default SupplierDropdown;